export function isCompressionSupported() {
  return 'CompressionStream' in window
}

export async function compress(data: Record<string, any>) {
  if (!isCompressionSupported()) {
    return data
  }

  const stream = new Blob([JSON.stringify(data)], {
    type: 'application/json',
  }).stream()

  const compressedReadableStream = stream //
    .pipeThrough(new CompressionStream('gzip'))

  return await new Response(compressedReadableStream)
}

export async function compressAsBlob(data: Record<string, any>) {
  if (!isCompressionSupported()) {
    return data
  }

  return await (await compress(data)).blob()
}
